import IService from '../IService';
import app from 'app';

export default IService.extend({
  get(options) {
    if (options.type === 'ALL') {
      options.type = null;
    }

    options = Object.assign(
      {
        /** search query */
        q: '',
        type: null,
        programmerId: null,
        brandId: null,
        myWork: false,
        page: 0,
        /** page size */
        size: app.DASHBOARD_RESULTS_PER_PAGE,
        _: Date.now(),
      },
      options
    );

    return new Promise((resolve, reject) =>
      $.ajax({
        url: app.apiUrl('/api/v1/producedStoryPreviews', options),
        type: 'GET',
        timeout: app.TIME.minute(),

        dataType: 'json',

        error(jqXHR, textStatus, errorThrown) {
          if ('abort' !== textStatus) {
            reject({ error: errorThrown });
          }
        },

        success(res) {
          if (_.isEmpty(res.storyPreviews)) {
            resolve({ videos: [], noMore: true });
          } else {
            resolve({
              videos: res.storyPreviews,
              noMore: !res.storyPreviews || !res.storyPreviews.length,
            });
          }
        },
      })
    );
  },

  delete({ id }) {
    const promise = new $.Deferred();

    $.ajax({
      url: app.apiUrl(`/api/v2/producedStories/${id}`),
      type: 'DELETE',

      error: (jqXHR) => {
        if (jqXHR.status === 404) {
          app.dialog
            .error({
              type: app.dialog.types.ERROR_1,
              title: app.culture.story.deleteError,
              showContactCsm: true,
            })
            .then(promise.reject);
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(promise.reject);
        }
      },

      dataType: 'json',
      success: (response) => {
        promise.resolve(response);
      },
    });

    return promise.promise();
  },

  view({ id }) {
    const promise = new $.Deferred();

    $.ajax({
      url: app.apiUrl(`/api/v2/producedStories/${id}/view`),
      type: 'POST',

      error: (jqXHR) => {
        if (jqXHR.status === 404) {
          app.dialog
            .error({
              type: app.dialog.types.ERROR_1,
              title: app.culture.story.deleteError,
              showContactCsm: true,
            })
            .then(promise.reject);
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(promise.reject);
        }
      },

      success: () => {
        promise.resolve();
      },
    });

    return promise.promise();
  },

  async sendStoryToCMS({ storyId }) {
    const res = await fetch(
      app.apiUrl(`/api/v2/producedStories/${storyId}/syndications`),
      {
        method: 'POST',
        credentials: 'include',
        headers: { ...app.rootStore.getters['user/xhrHeaders'] },
      }
    );
    if (!res.ok) {
      throw new Error('Error Publishing to CMS');
    }
  },

  disabledCustomOverlays({ storyId, targetProgrammerId, themeId }) {
    if (!themeId) {
      app.doctorController.report(
        '// TODO: producedStories - disabledCustomOverlays - missing themeId'
      );
      return Promise.reject();
    }

    return new Promise((resolve, reject) => {
      fetch(
        app.apiUrl(
          `/api/v2/producedStories/${storyId}/disabledCustomOverlays`,
          {
            destProgrammerId: targetProgrammerId,
            destThemeId: themeId,
          }
        ),
        {
          method: 'GET',
          credentials: 'include',
          headers: { ...app.rootStore.getters['user/xhrHeaders'] },
        }
      )
        .then((res) => {
          return res.ok ? res.json() : Promise.reject();
        })
        .then((json) => {
          if (Object.getOwnPropertyDescriptor(json, 'disabledCustomOverlays')) {
            resolve(json);
          } else {
            app.doctorController.report(
              `disabledCustomOverlays bad response: ${JSON.stringify(json)}`
            );
            reject();
          }
        })
        .catch(reject);
    });
  },

  createDraftStoryFromProducedStory({
    storyId,
    newTitle,
    destProgrammerId,
    storyStartPoint,
    brandId,
    themeId,
  }) {
    const deferred = new $.Deferred();

    console.log('\u26A1createDraftStoryFromProducedStory\u26A1');
    $.ajax({
      url: app.apiUrl(`/api/v2/producedStories/${storyId}/draftStories`),
      type: 'POST',

      contentType: 'application/json',
      data: JSON.stringify({
        newTitle,
        destProgrammerId,
        storyStartPoint,
        destBrandId: brandId,
        destThemeId: themeId,
      }),

      error: (jqXHR, textStatus) => {
        if ('abort' === textStatus) {
          deferred.reject(this.createError(jqXHR));
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(deferred.reject);
        }
      },

      dataType: 'json',
      success: (res) => {
        deferred.resolve(res);
      },
    });

    return deferred.promise();
  },

  createProducedStoryFromProducedStory({
    storyId,
    newTitle,
    destProgrammerId,
    storyStartPoint,
    brandId,
    themeId,
  }) {
    const deferred = new $.Deferred();

    console.log('\u26A1createProducedStoryFromProducedStory\u26A1');
    $.ajax({
      url: app.apiUrl(`/api/v2/producedStories/${storyId}`),
      type: 'POST',

      contentType: 'application/json',
      data: JSON.stringify({
        newTitle,
        destProgrammerId,
        storyStartPoint,
        destBrandId: brandId,
        destThemeId: themeId,
      }),

      error: (jqXHR, textStatus) => {
        if ('abort' === textStatus) {
          deferred.reject(this.createError(jqXHR));
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(deferred.reject);
        }
      },

      dataType: 'json',
      success: (res) => {
        deferred.resolve(res);
      },
    });

    return deferred.promise();
  },

  moveToDraft(storyId) {
    const rv = new _.ColdPromise();

    $.ajax({
      url: app.apiUrl(`/api/v2/producedStories/${storyId}/moveToDraft`),
      type: 'PUT',

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success() {
        rv.resolve();
      },
    });

    return rv;
  },
});
